import React, { useState, useEffect } from "react";
import { toPrice } from "../../../helpers/stringFormat";
import AccountHeaderFormatter from "./accountHeaderFormatter";
import { LineChart } from '@mui/x-charts/LineChart'
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import moment from 'moment';


const ChangeInCashInfo = (props) => {
	const [graphData, setGraphData] = useState([]);

	useEffect(() => {
		if (props.loadingTransactions || !props.completedTransactions || props.completedTransactions.length === 0) {
			return;
		}
		const validTransactions = props.completedTransactions && props.completedTransactions.filter((txn) => txn.timestamp && txn.balance);

		validTransactions.sort((a, b) => {
			const dateA = moment(a.timestamp);
			const dateB = moment(b.timestamp);
			return dateA.valueOf() - dateB.valueOf();
		});

		let eodBalances = validTransactions.reverse().reduce((obj, val, idx) => {
			let txnDate = moment(val.timestamp).format("YYYY-MM-DD")
			if (obj[txnDate] === undefined) obj[txnDate] = val.balance
			return obj;
		}, {})

		const newGraphData = Object.keys(eodBalances).map((key) => (
			{ 'date': key, 'balance': eodBalances[key] }
		)).reverse().filter((txn) => txn.balance !== 0.00 && txn.balance !== '0.00');
		// TODO: eventually we wil remove this equality, as of Mar 3 2025 this was a 
		// placeholder for balances, we started saving in early february
		// we should remove this in april

		if (newGraphData.length > 2) {
			setGraphData(newGraphData)
		} else {
			setGraphData([])
		}

	}, [props.completedTransactions]);

	const formatCashChange = (amt, suffix) => {

		return <Stack direction="row">
			<Typography variant={"h5"} color={amt >= 0 ? "primary" : ""} marginRight={1}>{toPrice(
				amt,
				{
					negPrefix: "(",
					negSuffix: ")",
					posPrefix: "+",
					currencySymbol: "$"
				}
			)}</Typography>
			<Typography color={"text.disabled"}>{suffix}</Typography>
		</Stack>
	}

	return (
		<AccountHeaderFormatter
			title="Cash Insights"
			body={<Stack direction="column" sx={{ alignItems: 'center', display: 'flex' }}>
				<Stack direction="row" spacing={1}>
					<Chip label={formatCashChange(props.last1dayTxnsTotal, "Last Day")} />
					<Chip label={formatCashChange(props.last30daysTxnsTotal, "Last 30 Days")} />
				</Stack>
				<Box sx={{ width: 500, height: 300, alignItems: 'center', display: 'flex' }}>
					<LineChart
						loading={props.loadingTransactions}
						margin={{ right: 1 }}
						series={[{
							data: graphData.map((entry) => Number(entry.balance)),
							color: "#1890FF",
							curve: "linear",
							valueFormatter: (value) => toPrice(value, { currencySymbol: "$" }),
						}]}
						xAxis={[{
							data: graphData.map((entry) => entry.date),
							scaleType: "point",
							sx: { '.MuiChartsAxis-tick, .MuiChartsAxis-line': { stroke: '#1890FF' } }
						}]}
						yAxis={[{
							valueFormatter: (value) => toPrice(value, { currencySymbol: "$" }),
							sx: { '.MuiChartsAxis-tick, .MuiChartsAxis-line': { stroke: '#1890FF' } }
						}]}
						width={400}
					/>
				</Box>
			</Stack>}
		/>
	);
};

export default ChangeInCashInfo;
